/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useRef } from 'react';

export default function SearchResults({
  onResultSelect,
  setQuery,
  results,
  formatSearchResult,
  noResultsText,
}) {
  const searchResultsRef = useRef();

  // Check if there is enough space to display the search results below the search input
  useEffect(() => {
    const searchResults = searchResultsRef.current;
    const searchResultsHeight = searchResults.getBoundingClientRect().height;
    const searchResultsTop = searchResults.getBoundingClientRect().top;
    const searchResultsBottom = searchResults.getBoundingClientRect().bottom;
    const windowHeight = window.innerHeight;

    if (searchResultsBottom > windowHeight) {
      searchResults.style.top = `-${searchResultsHeight}px`;
    } else if (searchResultsTop < 0) {
      searchResults.style.top = '0';
    }
  }, [results]);

  let content = null;

  if (results && results.length && !formatSearchResult) {
    content = results.map((result) => (
      <li
        key={result.id}
        className="p-1 px-3 text-sm cursor-pointer"
        onClick={() => {
          onResultSelect(result);
          setQuery('');
        }}
      >
        {/* id: {result.id}, name: {result.name} */}
        {result.TIN_type === 'EIN'
          ? result.entity_name
          : `${result.first_name} ${result.last_name}`}
      </li>
    ));
  } else if (results && results.length && formatSearchResult) {
    content = results.map((result) => (
      <li
        key={result.id}
        className="p-1 px-3 text-sm cursor-pointer"
        onClick={() => {
          onResultSelect(result);
          setQuery('');
        }}
      >
        {formatSearchResult(result)}
      </li>
    ));
  } else if (results && !results.length) {
    content = (
      <li className="p-1 px-3 text-sm">
        {noResultsText || 'No borrowers found'}
      </li>
    );
  }

  return (
    <ul
      ref={searchResultsRef}
      className="absolute w-full max-h-[301px] bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 overflow-y-auto z-10"
    >
      {content}
    </ul>
  );
}
